module.exports = __webpack_public_path__ + "img/f1a8a45.jpg";